<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-11T13:51:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-02-01T10:43:40+02:00
@Copyright: Diversitude 2021
-->



<template>
    <Layout>
         <b-row>
            <b-col xl="2" sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>

            <b-col xl="10"  sm="9" v-if="showDefaultScreen">
                <Documents
                @edit="editDoc"
                @createNew="newDoc"
                @showStats="showStatsHandler"
                @showDistribution="showDistributionHandler"
                />
            </b-col>
        </b-row>
        <!-- <Documents
                @edit="editDoc"
                @createNew="newDoc"
                @showStats="showStatsHandler"
                @showDistribution="showDistributionHandler"
                /> -->
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
//import Layout from "../../layouts/main";
import Documents from '@/components/documents/documentList.vue'
import {layoutMethods} from '@/state/helpers';
export default {
    data:() => ({
        isEditing: false,
        isEditingClient: false,
        isNewDocument: false,
        hideMenu: false,

        showStats: false,
        showDistribution: false,
    }),
    components:{
        Layout,
        //eslint-disable-next-line
        Menu,
        Documents,
    },
    computed: {
        showDefaultScreen(){
            if(this.showStats == false && this.showDistribution == false){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            this.showDocumentsMenu();
            this.isEditing = false;
            this.isEditingClient = false;
            this.showStats = false;
            this.showDistribution = false;
        },
        editDoc(id){
            this.showEditMenu();
            console.log(id);
            this.isNewDocument = false;
            this.isEditing = true;
        },
        newDoc(){
            this.isNewDocument = true;
            this.isEditing = true;
            this.showEditMenu();
        },
        showDocumentsMenu(){
            this.updateMenuType({
                type: 'documents',
                showMenu: true,
                showRoutes: false,
            })
        },
        showEditMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },

        //* document right click events */
        showStatsHandler(){
            this.hideMenu = true;

            this.isEditing = false;
            this.showStats = true;
            this.showDistribution = false,

            this.updateMenuType({
                type: 'stats',
                showMenu: false,
                showRoutes: false,
            })
        },
        showDistributionHandler(){
            this.hideMenu = true;

            this.isEditing = false;
            this.showStats = false;
            this.showDistribution = true;

            this.updateMenuType({
                type: 'distribution',
                showMenu: false,
                showRoutes: false,
            })
        },
        editClientSopHandler(){
            this.hideMenu = true;
            this.updateMenuType({
                type: 'for_client_document',
                showMenu: false,
                showRoutes: false,
            });
            this.showStats = false;
            this.isEditingClient = true;
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'documents',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
